import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import TopicIndex from './components/TopicIndex';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import MediaSection from './components/MediaSection';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Ranking from './components/Ranking';
import AppPromo from './components/AppPromo';
import Topics from './components/Topics';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <TopicIndex />
        <Carousel />
        <Comments />
        <MediaSection />
        <Cards />
        <Contact />
        <Ranking />
        <AppPromo />
        <Topics />
        <Updates />
        <FAQ />
        <About />
      </main>
      <Footer />
    </>
  );
}